import type { SVGProps } from 'react'
import * as React from 'react'

const iconButtonrefreshAddress = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={48} height={48} rx={24} fill="#2ACC88" />
    <path
      d="M33 22C33 29 24 35 24 35C24 35 15 29 15 22C15 19.6131 15.9482 17.3239 17.636 15.636C19.3239 13.9482 21.6131 13 24 13C26.3869 13 28.6761 13.9482 30.364 15.636C32.0518 17.3239 33 19.6131 33 22Z"
      stroke="white"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 25C25.6569 25 27 23.6569 27 22C27 20.3431 25.6569 19 24 19C22.3431 19 21 20.3431 21 22C21 23.6569 22.3431 25 24 25Z"
      stroke="white"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x={27} y={23} width={12} height={12} rx={6} fill="#2ACC88" />
    <path d="M37.2803 31.0589L35.444 32.119L34.3838 30.2827" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M28.4951 27.1536L30.3315 26.0934L31.3916 27.9297" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M32.3054 25.978C32.8336 25.8799 33.3781 25.9173 33.888 26.0866C34.3979 26.256 34.8566 26.5517 35.2213 26.9462C35.586 27.3408 35.8448 27.8212 35.9736 28.3429C36.1023 28.8645 36.0969 29.4102 35.9577 29.9291L35.4432 32.1196M30.3316 26.0933L29.8171 28.2838C29.6779 28.8027 29.6724 29.3484 29.8012 29.8701C29.93 30.3917 30.1888 30.8722 30.5535 31.2667C30.9182 31.6612 31.3769 31.957 31.8868 32.1263C32.3967 32.2956 32.9412 32.333 33.4694 32.2349"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default iconButtonrefreshAddress
